import { render, staticRenderFns } from "./BlocoInformacaoBR.vue?vue&type=template&id=1dcad69c&lang=pug"
import script from "./BlocoInformacaoBR.vue?vue&type=script&lang=js"
export * from "./BlocoInformacaoBR.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacaoBR.vue?vue&type=style&index=0&id=1dcad69c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports